import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { NotificationRuleUpdateInput } from "@colab/shared";

export type UpdateNotificationRuleInput = {
  ruleId: string;
  patch: NotificationRuleUpdateInput;
};

// PATCH /api/settings/notifications/rules/:id
//
// Partial-patch update — unset keys leave the existing column value alone.
// Replaces revalidatePath("/admin/settings/notifications") from the legacy
// action.
export function useUpdateNotificationRule() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, UpdateNotificationRuleInput>({
    mutationFn: ({ ruleId, patch }) =>
      apiFetch<{ ok: true }>(`/settings/notifications/rules/${ruleId}`, {
        method: "PATCH",
        body: JSON.stringify(patch),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.notificationRules() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.settings.notificationInsights(),
      });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to update notification rule");
    },
  });
}
